var _circle, _ellipse, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLsqSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.4,
    r: 14,
    fill: "url(#paint0_linear_1379_19008)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0002,
    cy: 24.4002,
    rx: 10.3478,
    ry: 10.3478,
    fill: "url(#paint1_linear_1379_19008)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8275 20.5826C30.5911 21.3641 30.5766 22.6165 29.7952 23.3801L24.1888 28.8584C23.4201 29.6095 22.1923 29.6095 21.4236 28.8584L18.5083 26.0097C17.7268 25.2461 17.7124 23.9936 18.4759 23.2122C19.2395 22.4307 20.492 22.4163 21.2734 23.1798L22.8062 24.6776L27.03 20.5503C27.8115 19.7867 29.0639 19.8012 29.8275 20.5826Z",
    fill: "url(#paint2_linear_1379_19008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1379_19008",
    x1: 24,
    y1: 10.4,
    x2: 24,
    y2: 38.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34AC0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1379_19008",
    x1: 24.0002,
    y1: 14.0524,
    x2: 24.0002,
    y2: 34.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABEB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CE38A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1379_19008",
    x1: 24.1517,
    y1: 19.9869,
    x2: 24.1517,
    y2: 29.4217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34AC0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsqSuccess);
export default __webpack_public_path__ + "static/media/lsq_success.78d71d2acd07aae21552bf6279b8f6ea.svg";
export { ForwardRef as ReactComponent };